import Link from "next/link";
import {UrlObject} from "url";
import {Button, Text, Stack} from "@chakra-ui/react";
import {FiArrowUpRight} from "@onemind-services-llc/react-icons-ng/fi";
import {TEXT_VARIANTS} from "@/theme/components/text";
import {BUTTON_VARIANTS} from "@/theme/components/button";

type ContentProps = {
  link?: string | UrlObject;
  text: string;
};

export const ContentWithTextAndLink = (props: ContentProps) => {
  const {link, text} = props;
  const textVariant = TEXT_VARIANTS.BODY2;

  return (
    <Stack height={"100%"} justifyContent={"space-between"} spacing={4}>
      <Text color={"text.100"} variant={textVariant} _groupHover={{color: "white"}}>
        {text}
      </Text>
      {link && (
        <Button
          as={Link}
          cursor={"pointer"}
          href={link}
          variant={BUTTON_VARIANTS.LINK}
          color="primary.200"
          _groupHover={{backgroundColor: "white"}}
          w={"fit-content"}
          px={3}
          py={1.5}
        >
          <Text fontWeight={600} variant={textVariant}>
            Explore more
          </Text>
          <FiArrowUpRight fontSize={"24px"} />
        </Button>
      )}
    </Stack>
  );
};
